// GSTIN validator — 15-char alphanumeric
// Format: 2 digit state code + 10 char PAN + 1 digit entity + Z + 1 checksum char
export const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
const STATE_CODES = new Set([
  '01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20',
  '21','22','23','24','26','27','29','30','31','32','33','34','35','36','37','38',
]);

/**
 * Validate GSTIN.
 * We validate:
 *  1. length = 15
 *  2. Indian GSTIN regex (state+PAN+entity+Z+check)
 *  3. First 2 digits are a valid state code
 *  4. Checksum (informational — if it matches, we flag verified=true; if not, we STILL
 *     accept the GSTIN as "valid format" to avoid false negatives on real GSTINs due
 *     to checksum implementation variations).
 */
export function validateGSTIN(gstin) {
  if (!gstin) return { valid: false, reason: 'Empty' };
  const normalized = String(gstin).trim().toUpperCase();
  if (normalized.length !== 15) return { valid: false, reason: 'Must be 15 characters' };
  if (!GSTIN_REGEX.test(normalized)) return { valid: false, reason: 'Invalid format' };
  const stateCode = normalized.slice(0, 2);
  if (!STATE_CODES.has(stateCode)) return { valid: false, reason: 'Invalid state code' };
  const expected = gstinChecksum(normalized.slice(0, 14));
  const checksumMatches = expected === normalized[14];
  return { valid: true, stateCode, checksumVerified: checksumMatches };
}

// Returns the expected 15th character based on the first 14
function gstinChecksum(first14) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let sum = 0;
  for (let i = 0; i < 14; i++) {
    const codePoint = chars.indexOf(first14[i]);
    if (codePoint < 0) return '';
    const weight = (i % 2 === 0) ? 1 : 2;
    let product = codePoint * weight;
    product = Math.floor(product / chars.length) + (product % chars.length);
    sum += product;
  }
  const remainder = sum % chars.length;
  const checkCodePoint = (chars.length - remainder) % chars.length;
  return chars[checkCodePoint];
}

export function stateCodeFromGSTIN(gstin) {
  if (!gstin || gstin.length < 2) return '';
  return String(gstin).slice(0, 2);
}
